import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";

const ReBidCancelBox = ({ userType = "Buyer", open, onCancel, onOk }) => {
  return (
    <div>
      <DiaglogBox
        open={open}
        onOk={onOk}
        onCancel={onCancel}
        width={617}
        className
      >
        <div className="drop-shadow-custom">
          <div className="flex justify-center items-center relative ">
            <img
              className="mini-photo ml-4 my-3 "
              src="/images/Bidplaced.png"
              width="100"
              height="100"
              alt=""
            />
            <div className="absolute top-auto left-auto ">
              <img
                className="mini-photo ml-4 my-3 "
                src="/images/Bidplacedsec.svg"
                width="50"
                height="50"
                alt=""
              />
            </div>
          </div>

          <h1 className="text-center text-black mb-2 text-[32px] font-medium">
            Bid Cancelled Successfully!
          </h1>

          <div className="flex justify-center my-5">
            <Button
              varient="primary"
              borderColor="blue"
              className=" w-[16.875rem] h-[72px] px-9 py-2 text-[20px] text-white font-bold  bg-blue-800   "
              onClick={onOk}
            >
              Go Back
            </Button>
            {/* <Button
              varient="primary"
              borderColor="blue"
              className=" w-[15.625rem] h-[72px] px-9 py-2 text-[20px] border-[1px] border-blue-800 font-bold text-blue-800 bg-blue-100   "
              onClick={onCancel}
            ></Button> */}
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default ReBidCancelBox;
